import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { AddCircle, BuildCircle } from '@mui/icons-material';

interface Props {
  onAddCondition: VoidFunction;
  onAddCustomCondition: VoidFunction;
}

export const ActionPanel = ({ onAddCondition, onAddCustomCondition }: Props) => (
  <Stack direction="row" justifyContent="space-between">
    <Typography variant="h6" component="span">
      Score Criterias
    </Typography>

    <Stack direction="row" gap="1rem">
      <Button size="small" startIcon={<BuildCircle />} onClick={() => onAddCustomCondition()}>
        Add custom сriteria
      </Button>

      <Button size="small" startIcon={<AddCircle />} onClick={onAddCondition}>
        Add сriteria
      </Button>
    </Stack>
  </Stack>
);
